<template>
  <div class="app" :class="{ hidden: !Visible }">
    <transition-group name="fade">
      <Loader key="Loader" v-if="Loading" />
      <div class="app__selector" :class="{ dark: DarkMode }" key="App" v-else>
        <div class="app__selector__header">
          <Header
            :Language="aplicacion.languageSel"
            :Coleccion="aplicacion.coleccionSel"
            :Options="Options"
            @Share="SetShare"
            :DarkMode="DarkMode"
            @DarkMode="SetDarkMode"
            :Hotspots="Hotspots"
            @Hotspots="SetHotspots"
            :Zoom="Zoom"
            @Zoom="SetZoom"
            :FullScreen="FullScreen"
            @FullScreen="SetFullScreen"
            @Close="SetClose"
          />
        </div>
        <div class="app__selector__content">
          <Datos :aplicacion="aplicacion" />
          <Pricing />
          <Canvas :Open="Open" />
          <Buttons
            :Language="aplicacion.languageSel"
            :Open="Open"
            @Open="SetOpen"
            :Buttons="Buttons"
            :Content="Content"
            @Content="SetContent"
            :Comparador="Comparador"
            @Comparador="SetComparador"
          />
          <Menu
            :Open="Open"
            :Content="Content"
            :aplicacion="aplicacion"
            @Grupo="SetGrupo"
            @Acabado="SetAcabado"
          />
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import axios from "axios";
import XLSX from "xlsx";

import Datos from "@/components/Datos.vue";

import Loader from "@/components/Loader.vue";
import Header from "@/components/Header.vue";
import Pricing from "@/components/Pricing.vue";
import Canvas from "@/components/Canvas.vue";
import Buttons from "@/components/Buttons.vue";
import Menu from "@/components/Menu.vue";

import Aplicacion from "@/clases/Aplicacion.js";
import Coleccion from "@/clases/Coleccion.js";
import Side from "@/clases/Side.js";
import Campo from "@/clases/Campo.js";
import Grupo from "@/clases/Grupo.js";
import Acabado from "@/clases/Acabado.js";
import Literal from "@/clases/Literal.js";
import datos3Drender from "@/clases/Datos3Drender.js";

export default {
  name: "App",
  components: {
    Datos,

    Loader,
    Header,
    Pricing,
    Canvas,
    Buttons,
    Menu,
  },
  data() {
    return {
      Visible: false,
      Loading: true,
      Open: false,
      Content: "",
      Comparador: false,
      Buttons: [
        {
          cod: "caracteristicas",
          miniatura: "Global/Caracteristicas.svg",
          literales: [
            {
              codIdioma: "es",
              texto: "Caracteristicas",
            },
          ],
        },
        {
          cod: "resumen",
          miniatura: "Global/Resumen.svg",
          literales: [
            {
              codIdioma: "es",
              texto: "Resumen",
            },
          ],
        },
        {
          cod: "comparador",
          miniatura: "Global/Comparador.svg",
          literales: [
            {
              codIdioma: "es",
              texto: "Comparador",
            },
          ],
        },
        {
          cod: "cerrar",
          miniatura: "Global/Cerrar.svg",
          literales: [
            {
              codIdioma: "es",
              texto: "Cerrar",
            },
          ],
        },
      ],
      DarkMode: false,
      Hotspots: false,
      Zoom: false,
      FullScreen: false,
      Options: [
        {
          cod: "Share",
          miniatura: "Global/Share.svg",
          literales: [
            {
              codIdioma: "es",
              texto: "Compartir configuración",
            },
          ],
        },
        {
          cod: "DarkMode",
          miniatura: ["Global/DarkMode.svg", "Global/LightMode.svg"],
          literales: [
            {
              literales: [
                {
                  codIdioma: "es",
                  texto: "Modo oscuro",
                },
              ],
            },
            {
              literales: [
                {
                  codIdioma: "es",
                  texto: "Modo claro",
                },
              ],
            },
          ],
        },
        {
          cod: "Hotspots",
          miniatura: ["Global/HotspotOFF.svg", "Global/Hotspot.svg"],
          literales: [
            {
              literales: [
                {
                  codIdioma: "es",
                  texto: "Ocultar puntos calientes",
                },
              ],
            },
            {
              literales: [
                {
                  codIdioma: "es",
                  texto: "Mostrar puntos calientes",
                },
              ],
            },
          ],
        },
        {
          cod: "Zoom",
          miniatura: ["Global/Zoom.svg", "Global/ZoomOFF.svg"],
          literales: [
            {
              literales: [
                {
                  codIdioma: "es",
                  texto: "Activar Zoom",
                },
              ],
            },
            {
              literales: [
                {
                  codIdioma: "es",
                  texto: "Desactivar Zoom",
                },
              ],
            },
          ],
        },
        {
          cod: "FullScreen",
          miniatura: ["Global/FullScreen.svg", "Global/FullScreenOFF.svg"],
          literales: [
            {
              literales: [
                {
                  codIdioma: "es",
                  texto: "Pantalla completa",
                },
              ],
            },
            {
              literales: [
                {
                  codIdioma: "es",
                  texto: "Salir de pantalla completa",
                },
              ],
            },
          ],
        },
      ],
      separador: "&",
      extension: "webp",
      tokenProvisional:
        "Bearer " +
        "ZXlKMGVYQWlPaUpLVjFRaUxDSmhiR2NpT2lKSVV6STFOaUo5LmV5SnlaVzVrWlhKeklqcDBjblZsTENKbGVIQWlPakUzTURJeE9UTXpOekI5Lmh6d0Y1ZWNIeWc3X2REaFVrWUVEcFNWeDQ5QWxBTXlBa1pWQ1RGa3JEMVE=",
      datos3Drender: { gruposCampos: [], gruposTrad: [], revestimiento: [] },
      aplicacion: new Object(),
    };
  },
  props: {
    idclase: new String(),
    idmaterial: new String(),
    idcoleccion: new String(),
    locale: new String(),
    token: new String(),
  },
  mounted() {
    if (window.location.href.includes("localhost")) {
      this.SetWorkAround();
    }
    this.SetAplicacion();
  },
  methods: {
    //CARGA
    SetWorkAround() {
      document.documentElement.style.overflow = "hidden";
      this.Visible = true;
      this.idclase = "perth";
      this.idmaterial = "QUI01SC0002";
      this.idcoleccion = "QUI";
      this.locale = "es";

      var config;

      if (this.idclase != "") {
        config = {
          method: "get",
          maxBodyLength: Infinity,
          url:
            "https://clients.docciagroup.com/api/renders/configurable?codigo=" +
            this.idclase +
            "&lng=1",

          headers: {
            Authorization: this.tokenProvisional,
            Cookie: "PHPSESSID=88g4hbpc7hq1ienv3cpqkampuu",
          },
        };
        var that = this;
        axios
          .request(config)
          .then((response) => {
            console.log(
              "******************** Carga y crea aplicacion *********************************"
            );
            that.GetDatos3Drender(that.idclase, response.data);
          })
          .catch((error) => {
            console.log("Error al llamar al servicio configurable", error);
          });
      } else {
        console.log("that.idclase nulo", that.idclase);
        alert("NO RECIBIMOS CONFIGURABLE - SOLO STANDARD");
      }
    },
    SetAplicacion() {
      this.locale = "es";
      var that = this;

      document.addEventListener("3drender-open-modal", function (event) {
        window.scrollTo(0, 0);
        document.documentElement.style.overflow = "hidden";
        that.Visible = true;

        var config;

        if (that.idclase != "") {
          config = {
            method: "get",
            maxBodyLength: Infinity,
            url:
              "https://clients.docciagroup.com/api/renders/configurable?codigo=" +
              that.idclase.toUpperCase() +
              "&lng=1",

            headers: {
              Authorization: that.tokenProvisional,
              Cookie: "PHPSESSID=88g4hbpc7hq1ienv3cpqkampuu",
            },
          };
          axios
            .request(config)
            .then((response) => {
              console.log(
                "******************** Carga y crea aplicacion *********************************"
              );
              that.GetDatos3Drender(that.idclase, response.data);
            })
            .catch((error) => {
              console.log("Error al llamar al servicio configurable", error);
            });
        } else {
          console.log("that.idclase nulo", that.idclase);
          alert("NO RECIBIMOS CONFIGURABLE - SOLO STANDARD");
        }
      });
    },
    GetDatos3Drender(aplicacionCod, datos) {
      var that = this;
      var url = "/Files/DATOS3DRENDER.xlsx";

      axios({
        url: url,
        method: "GET",
        responseType: "blob",
      })
        .then((res) => {
          const reader = new FileReader();
          reader.readAsBinaryString(res.data);
          reader.onload = (e) => {
            var element;
            if (e.target == null || e.target == undefined) {
              element = e.path[0];
            } else {
              element = e.target;
            }
            var data = element.result;
            var workbook = XLSX.read(data, { type: "binary" });

            // Creación de grupos y campos asignados
            var sheet = XLSX.utils.sheet_to_json(
              workbook.Sheets["GRUPOS&CAMPOS"]
            );

            var cellValue;
            that.datos3Drender.gruposCampos = [];
            // Recorriendo las filas y columnas
            for (const row of sheet) {
              var linea = {};
              linea.grupo = row["grupo"];
              linea.visual = row["visual"];
              linea.includes = [];

              // Recorriendo las columnas dentro de cada fila
              for (const column in row) {
                cellValue = row[column];
                if (column.includes("includes")) {
                  // Son los includes
                  linea.includes.push(cellValue);
                }
              }
              that.datos3Drender.gruposCampos.push(linea);
            }

            // Traducción de grupos
            sheet = XLSX.utils.sheet_to_json(workbook.Sheets["GRUPOS&TRAD"]);

            that.datos3Drender.gruposTrad = [];
            // Recorriendo las filas y columnas
            for (const row of sheet) {
              linea = {};
              linea.grupo = row["grupo"];
              linea.literales = [];
              // Recorriendo las columnas dentro de cada fila
              for (const column in row) {
                cellValue = row[column];
                if (column == that.locale) {
                  // Es una traducción
                  linea.literales.push(this.CreaLiteral(cellValue));
                }
              }
              that.datos3Drender.gruposTrad.push(linea);
            }

            // Grupo revestimiento
            sheet = XLSX.utils.sheet_to_json(workbook.Sheets["REVESTIMIENTO"]);
            that.datos3Drender.revestimiento = sheet;
            console.log("EXCEL", that.datos3Drender);

            that.aplicacion = that.CreaAplicacion(aplicacionCod, datos);

            setTimeout(() => {
              that.Loading = false;
            }, 1800);
          };
        })
        .catch((error) => {
          console.log("ERROR");
          console.log(error);
          if (error.response) {
            // El servidor respondió con un código de estado diferente de 2xx (errores HTTP)
            console.error(
              "Error HTTP:",
              error.response.status,
              error.response.data
            );
          } else if (error.request) {
            // No se recibió ninguna respuesta del servidor (posible error de red)
            console.error(
              "No se pudo recibir una respuesta del servidor:",
              error.request
            );
          } else {
            // Error en la solicitud (por ejemplo, error de configuración de axios)
            console.error("Error en la solicitud:", error.message);
          }

          that.datos3Drender = new datos3Drender();
          console.log("JSON", that.datos3Drender);
          that.aplicacion = that.CreaAplicacion(aplicacionCod, datos);
          setTimeout(() => {
            that.Loading = false;
          }, 1800);
        });
    },
    CreaLiteral(texto) {
      var literal = new Literal();
      literal.codIdioma = this.locale;
      literal.texto = texto;
      return literal;
    },
    CreaAplicacion(coleccionCod, datos) {
      var aplicacion, coleccion, side, grupo, campo, acabado;
      var caracteristicas;
      var valores;
      var that = this;

      function NuevoGrupo(side, codGrupo) {
        var grupo = side.grupos.find((grupo) => grupo.cod == codGrupo);
        if (grupo == null) {
          grupo = new Grupo();
          grupo.cod = codGrupo;
          side.grupos.push(grupo);
          // Busca el literal del grupo en el idioma que llega en el prop
          var texto = that.datos3Drender.gruposTrad
            .filter((trad) => trad.grupo == codGrupo)[0]
            .literales.filter(
              (literal) => literal.codIdioma == that.locale
            )[0].texto;

          grupo.literales.push(that.CreaLiteral(texto));
        }
        return grupo;
      }

      function CreaCamposGrupos(side, campo) {
        var grupo;

        // Filtra aquellos grupos que contienen un include que casa
        var lineas = that.datos3Drender.gruposCampos.filter(
          (linea) =>
            linea.includes.filter((include) => campo.cod.includes(include))
              .length > 0
        );

        if (lineas.length == 1) {
          // Obtiene la traducción del grupo
          var texto = that.datos3Drender.gruposTrad
            .filter((trad) => trad.grupo == lineas[0].grupo)[0]
            .literales.filter(
              (literal) => literal.codIdioma == that.locale
            )[0].texto;

          grupo = NuevoGrupo(side, lineas[0].grupo);
          campo.visual = lineas[0].visual == "SI";
        } else if (lineas.length > 1) {
          console.log(
            campo.cod + " se encuentra en más de un grupo de includes",
            lineas
          );
          grupo = NuevoGrupo(side, "OTROS");
          campo.visual = "NO";
        } else {
          console.log(campo.cod + " no está en ningún grupo");
          grupo = NuevoGrupo(side, "OTROS");
          campo.visual = "NO";
        }
        return grupo;
      }

      function CreaRevestimiento(grupo) {
        // Recorriendo las filas y columnas
        var campoCod;
        var acabadoCod;
        var campo;
        var acabado;
        var texto;

        for (const row of that.datos3Drender.revestimiento) {
          campoCod = row["campo"];
          acabadoCod = row["acabado"];
          if (campoCod != undefined) {
            // Crea el campo si así lo indica la fila
            campo = new Campo();
            campo.cod = campoCod;
            campo.visual = true;
            campo.condicion = "";
            campo.relacion = "";
            campo.tipo = "tacos";
            // La etiqueta para la tradudcción es "c" + idioma: "c" de campo
            texto = row["c" + that.locale];
            campo.literales.push(that.CreaLiteral(texto));
            grupo.campos.push(campo);
          }
          // Crea el acabado
          acabado = new Acabado();
          acabado.cod = acabadoCod;
          acabado.taco =
            campo.cod + that.separador + acabado.cod + "." + that.extension;
          acabado.condicion = "";
          acabado.relacion = "";
          acabado.capa =
            coleccion.cod.toUpperCase() +
            that.separador +
            grupo.cod +
            that.separador +
            campo.cod +
            that.separador +
            acabado.cod +
            "." +
            that.extension;
          texto = row["a" + that.locale];
          acabado.literales.push(that.CreaLiteral(texto));
          campo.acabados.push(acabado);
          campo.acabadoSel = campo.acabados[0];
        }
      }

      function CreaPerfil(aplicacion) {
        var perfil = {};

        aplicacion.colecciones.forEach((coleccion) => {
          // Crea cada fila de la excel
          coleccion.sides[0].grupos.forEach((grupo) => {
            grupo.campos.forEach((campo) => {
              if (campo.acabadoSel != undefined) {
                perfil[campo.cod.toLowerCase()] = {
                  value: campo.acabadoSel.cod,
                };
              } else {
                perfil[campo.cod.toLowerCase()] = { value: 0 };
              }
            });
          });
        });
        return perfil;
      }
      // Crea el objeto aplicacion
      aplicacion = new Aplicacion();
      aplicacion.cod = "app";
      aplicacion.languageSel = this.locale;
      aplicacion.literales.push(this.CreaLiteral("app"));

      // Se carga una sola colección
      coleccion = aplicacion.colecciones[0] = new Coleccion();
      coleccion.cod = coleccionCod;
      coleccion.literales.push(this.CreaLiteral(coleccionCod));

      // Sólo nos llega una colección, la coleccionSel será la primera
      aplicacion.coleccionSel = coleccion;

      // Se crea el side 0, luego se duplicará el side 1
      side = new Side();
      side.cod = "left";
      side.id = 0;

      // El side seleccionado es el de la izquierda
      coleccion.sideSel = side;

      coleccion.sideSel;

      // Se rellena el objeto aplicación
      caracteristicas = datos.caracteristicas;
      caracteristicas.forEach((caracteristica) => {
        campo = new Campo();
        campo.literales.push(this.CreaLiteral(caracteristica.descripcion));

        // Se añade el campo
        campo.cod = caracteristica.codigo;
        campo.id = caracteristica.id;
        campo.condicion = caracteristica.condicion;
        campo.relacion = caracteristica.relacion;

        // Se asigna el campo a un grupo a la vez que crea el grupo si es necesario
        grupo = CreaCamposGrupos(side, campo);
        grupo.campos.push(campo);

        // Si no tiene valores es tipo input
        // Si tiene valores y es visual es de tipo lista
        // Si tiene valores y NO es visual es dropdown
        if (caracteristica.valores != undefined) {
          valores = caracteristica.valores;
          valores.forEach((valor) => {
            acabado = new Acabado();
            acabado.cod = valor.valor;
            acabado.id = valor.id;
            acabado.literales.push(this.CreaLiteral(valor.descripcion));
            acabado.relacion = valor.relacion;
            acabado.condicion = valor.condicion;
            // Sólo tiene capas si es campo visual
            if (campo.visual) {
              acabado.capa =
                coleccion.cod.toUpperCase() +
                this.separador +
                grupo.cod +
                this.separador +
                campo.cod +
                this.separador +
                acabado.cod +
                "." +
                this.extension;
              campo.tipo = "tacos";
              acabado.taco =
                campo.cod + this.separador + acabado.cod + "." + this.extension;
              campo.tipo = "tacos";
            } else {
              campo.tipo = "dropdown";
            }
            campo.acabados.push(acabado);
          });
          campo.acabadoSel = campo.GetAcabado(caracteristica.valorPorDefecto);
        } else {
          campo.acabadoSel = undefined;
          campo.tipo = "input";
        }
      });

      // Se añade el grupo de Revestimientos en el side
      grupo = NuevoGrupo(side, "REVESTIMIENTO");
      CreaRevestimiento(grupo);

      // El grupo seleccionado se asigna a aplicacion y es el primero del sideSel
      aplicacion.grupoSel = coleccion.sideSel.grupos[0];

      // HARDCODE 1: Se añaden los acabados que no existen
      // TIPO_VIDRIO
      campo = side.GetCampo("TIPO_VIDRIO");
      acabado = new Acabado();
      acabado.cod = "FL";
      acabado.literales.push(this.CreaLiteral("Flute"));
      campo.acabados.push(acabado);

      acabado = new Acabado();
      acabado.cod = "FLR";
      acabado.literales.push(this.CreaLiteral("Flute Rayas"));
      campo.acabados.push(acabado);

      acabado = new Acabado();
      acabado.cod = "MC";
      acabado.literales.push(this.CreaLiteral("Mirror Chrome"));
      campo.acabados.push(acabado);
      campo.acabadoSel = acabado;

      // DECORADO
      campo = side.GetCampo("DECORADO");
      acabado = new Acabado();
      acabado.cod = "BW3";
      acabado.literales.push(this.CreaLiteral("BLACK W3"));
      campo.acabados.push(acabado);
      acabado = new Acabado();
      acabado.cod = "BW5";
      acabado.literales.push(this.CreaLiteral("BLACK W5"));
      campo.acabados.push(acabado);
      acabado = new Acabado();
      acabado.cod = "BW10";
      acabado.literales.push(this.CreaLiteral("BLACK W10"));
      campo.acabados.push(acabado);
      acabado = new Acabado();
      acabado.cod = "BW15";
      acabado.literales.push(this.CreaLiteral("BLACK W15"));
      campo.acabados.push(acabado);
      // FIN HARDCODE 1: Se añaden los campos que no existen

      // Añade los campos compuestos
      if (coleccion.cod.toUpperCase() == "QUITO") {
        side.grupos.forEach((grupo) => {
          grupo.campos.forEach((campo) => {
            // HARDCODE 2: Campos compuestos
            // Campos cuya imagen está compuesta por los acabados de otros campos
            if (campo.cod == "TIPO_VIDRIO") {
              campo.acabados.forEach((acabado) => {
                if (acabado.cod != "MC") {
                  acabado.compuesto = side.GetCampo("PARED");
                } else {
                  acabado.compuesto = side.GetCampo("SUELO");
                }
              });
            }
            // Campos cuya imagen está compuesta con otro campo
            if (campo.cod == "POMO_ST") {
              campo.compuesto = side.GetCampo("COLOR_POMO_ST");
            }
            if (campo.cod == "COLOR_POMO_ST") {
              // La visualización de esta capa está en la capa combinada pomo/color
              campo.visual = false;
            }
            // FIN HARDCODE 2: Campos compuestos
          });
        });
      }

      // Ordena los campos dentro de los grupos, primero no visual
      side.grupos.forEach((grupo) => {
        grupo.campos.sort(function (a, b) {
          return a.visual - b.visual;
        });
      });

      /* DEBUG */
      // side.grupos.forEach((grupo) => {
      //   console.log("****************", grupo.cod, "****************");
      //   grupo.campos.forEach((campo) => {
      //     if (campo.compuesto == undefined) {
      //       console.log(campo.cod, campo.visual, campo.tipo);
      //     } else {
      //       console.log(
      //         campo.cod,
      //         campo.visual,
      //         campo.tipo,
      //         "|->",
      //         campo.compuesto.cod
      //       );
      //     }
      //   });
      // });
      /* DEBUG */

      // Se añaden los sides a la colección
      coleccion.sides.push(side);
      // Se crea el side derecho con los mismos datos que el izquierdo
      coleccion.sides[1] = new Side();
      coleccion.sides[1] = Object.assign(
        coleccion.sides[1],
        coleccion.sides[0]
      );
      // Se cambian los códigos para el side derecho
      coleccion.sides[1].cod = "right";
      coleccion.sides[1].id = 1;
      // Se crean los literales de ambos sides
      coleccion.sides[0].literales.push(this.CreaLiteral("Izquierda"));
      coleccion.sides[1].literales.push(this.CreaLiteral("Derecha"));

      // Se añade el perfil a aplicacion: necesario para validar relaciones.
      aplicacion.perfil = CreaPerfil(aplicacion);
      return aplicacion;
    },
    //GLOBALES
    SetOpen(Boolean) {
      if (this.Open != Boolean) {
        this.Open = Boolean;
      }
    },
    SetContent(String) {
      if (this.Content != String) {
        this.Content = String;
      }
    },
    SetComparador(Boolean) {
      if (this.Comparador != Boolean) {
        this.Comparador = Boolean;
      }
    },
    //HEADER
    SetShare() {
      console.log("Share");
    },
    SetDarkMode(Boolean) {
      if (this.DarkMode != Boolean) {
        this.DarkMode = Boolean;
      }
    },
    SetHotspots(Boolean) {
      if (this.Hotspots != Boolean) {
        this.Hotspots = Boolean;
      }
    },
    SetZoom(Boolean) {
      if (this.Zoom != Boolean) {
        this.Zoom = Boolean;
      }
    },
    SetFullScreen(Boolean) {
      if (this.FullScreen != Boolean) {
        this.FullScreen = Boolean;
      }
    },
    SetClose() {
      console.log("Close App");
    },
    //MENU
    SetGrupo(Object) {
      this.aplicacion.grupoSel = Object;
    },
    SetAcabado(CampoObject, AcabadoObject) {
      this.aplicacion.grupoSel.campos[
        this.aplicacion.grupoSel.campos.findIndex(
          (Campo) => Campo.cod == CampoObject.cod
        )
      ].acabadoSel = AcabadoObject;
      this.SetPerfil(CampoObject.cod.toLowerCase(), CampoObject.acabadoSel.cod);
    },
    SetPerfil(Campo, Value) {
      this.aplicacion.perfil[Campo].value = Value;
    },
  },
};
</script>

<style lang="scss">
.app {
  position: absolute;
  z-index: 1000;
  opacity: 1;
  width: 100%;
  height: 100dvh;
  overflow: hidden;
  background-color: white;
  -webkit-transition: opacity 0.35s ease-in-out;
  -moz-transition: opacity 0.35s ease-in-out;
  -ms-transition: opacity 0.35s ease-in-out;
  -o-transition: opacity 0.35s ease-in-out;
  transition: opacity 0.35s ease-in-out;
  &__selector {
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-color: white;
    -webkit-transition: background-color 0.35s ease-in-out;
    -moz-transition: background-color 0.35s ease-in-out;
    -ms-transition: background-color 0.35s ease-in-out;
    -o-transition: background-color 0.35s ease-in-out;
    transition: background-color 0.35s ease-in-out;
    &__header {
      width: 100%;
      height: $Header-height;
    }
    &__content {
      display: flex;
      width: 100%;
      height: calc(100% - $Header-height);
    }
    &.dark {
      background-color: #333333;
      -webkit-transition: background-color 0.35s ease-in-out;
      -moz-transition: background-color 0.35s ease-in-out;
      -ms-transition: background-color 0.35s ease-in-out;
      -o-transition: background-color 0.35s ease-in-out;
      transition: background-color 0.35s ease-in-out;
      & .header {
        background-color: #000000;
        -webkit-transition: background-color 0.35s ease-in-out;
        -moz-transition: background-color 0.35s ease-in-out;
        -ms-transition: background-color 0.35s ease-in-out;
        -o-transition: background-color 0.35s ease-in-out;
        transition: background-color 0.35s ease-in-out;
        &__info {
          &__logo {
            filter: invert(100%) brightness(0.85);
            -webkit-transition: filter 0.35s ease-in-out;
            -moz-transition: filter 0.35s ease-in-out;
            -ms-transition: filter 0.35s ease-in-out;
            -o-transition: filter 0.35s ease-in-out;
            transition: filter 0.35s ease-in-out;
          }

          &__collection {
            color: white;
            -webkit-transition: color 0.35s ease-in-out;
            -moz-transition: color 0.35s ease-in-out;
            -ms-transition: color 0.35s ease-in-out;
            -o-transition: color 0.35s ease-in-out;
            transition: color 0.35s ease-in-out;
          }
          &__separator {
            background-color: white;
            -webkit-transition: background-color 0.35s ease-in-out;
            -moz-transition: background-color 0.35s ease-in-out;
            -ms-transition: background-color 0.35s ease-in-out;
            -o-transition: background-color 0.35s ease-in-out;
            transition: background-color 0.35s ease-in-out;
          }
        }
        &__menu {
          &__option {
            &__items {
              &__item {
                &__option {
                  &__image {
                    filter: invert(100%);
                    -webkit-transition: opacity 0.35s ease-in-out,
                      filter 0.35s ease-in-out;
                    -moz-transition: opacity 0.35s ease-in-out,
                      filter 0.35s ease-in-out;
                    -ms-transition: opacity 0.35s ease-in-out,
                      filter 0.35s ease-in-out;
                    -o-transition: opacity 0.35s ease-in-out,
                      filter 0.35s ease-in-out;
                    transition: opacity 0.35s ease-in-out,
                      filter 0.35s ease-in-out;
                  }
                  &__name {
                    filter: invert(100%);
                    -webkit-transition: opacity 0.35s ease-in-out,
                      filter 0.35s ease-in-out;
                    -moz-transition: opacity 0.35s ease-in-out,
                      filter 0.35s ease-in-out;
                    -ms-transition: opacity 0.35s ease-in-out,
                      filter 0.35s ease-in-out;
                    -o-transition: opacity 0.35s ease-in-out,
                      filter 0.35s ease-in-out;
                    transition: opacity 0.35s ease-in-out,
                      filter 0.35s ease-in-out;
                  }
                }
              }
            }
            &__icon {
              filter: invert(100%);
              -webkit-transition: filter 0.35s ease-in-out;
              -moz-transition: filter 0.35s ease-in-out;
              -ms-transition: filter 0.35s ease-in-out;
              -o-transition: filter 0.35s ease-in-out;
              transition: filter 0.35s ease-in-out;
            }
          }
          &__separator {
            background-color: white;
            -webkit-transition: background-color 0.35s ease-in-out;
            -moz-transition: background-color 0.35s ease-in-out;
            -ms-transition: background-color 0.35s ease-in-out;
            -o-transition: background-color 0.35s ease-in-out;
            transition: background-color 0.35s ease-in-out;
          }
        }
      }
      & .pricing {
        background-color: rgba(0, 0, 0, 0.65);
        -webkit-transition: background-color 0.35s ease-in-out;
        -moz-transition: background-color 0.35s ease-in-out;
        -ms-transition: background-color 0.35s ease-in-out;
        -o-transition: background-color 0.35s ease-in-out;
        transition: background-color 0.35s ease-in-out;
      }
      & .canvas {
      }
      & .buttons {
        &__item {
          &__miniatura {
            background-color: #333333;
            -webkit-transition: background-color 0.35s ease-in-out;
            -moz-transition: background-color 0.35s ease-in-out;
            -ms-transition: background-color 0.35s ease-in-out;
            -o-transition: background-color 0.35s ease-in-out;
            transition: background-color 0.35s ease-in-out;
            &__image {
              filter: invert(100%) brightness(50%);
              -webkit-transition: filter 0.35s ease-in-out;
              -moz-transition: filter 0.35s ease-in-out;
              -ms-transition: filter 0.35s ease-in-out;
              -o-transition: filter 0.35s ease-in-out;
              transition: filter 0.35s ease-in-out;
            }
          }
          &__text {
            filter: invert(100%);
            -webkit-transition: opacity 0.35s ease-in-out,
              filter 0.35s ease-in-out;
            -moz-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
            -ms-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
            -o-transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
            transition: opacity 0.35s ease-in-out, filter 0.35s ease-in-out;
          }
          &.active {
            & .buttons__item {
              &__miniatura {
                &__image {
                  filter: invert(100%) brightness(100%);
                  -webkit-transition: filter 0.35s ease-in-out;
                  -moz-transition: filter 0.35s ease-in-out;
                  -ms-transition: filter 0.35s ease-in-out;
                  -o-transition: filter 0.35s ease-in-out;
                  transition: filter 0.35s ease-in-out;
                }
              }
            }
          }
        }
      }
      & .menu {
        background-color: #333333;
        -webkit-transition: margin-right 0.35s ease-in-out,
          background-color 0.35s ease-in-out;
        -moz-transition: margin-right 0.35s ease-in-out,
          background-color 0.35s ease-in-out;
        -ms-transition: margin-right 0.35s ease-in-out,
          background-color 0.35s ease-in-out;
        -o-transition: margin-right 0.35s ease-in-out,
          background-color 0.35s ease-in-out;
        transition: margin-right 0.35s ease-in-out,
          background-color 0.35s ease-in-out;
        &__caracteristicas {
          background-color: #333333;
          -webkit-transition: background-color 0.35s ease-in-out;
          -moz-transition: background-color 0.35s ease-in-out;
          -ms-transition: background-color 0.35s ease-in-out;
          -o-transition: background-color 0.35s ease-in-out;
          transition: background-color 0.35s ease-in-out;
          &__grupos {
            &__item {
              &__grupo {
                color: rgb(150, 150, 150);
                -webkit-transition: all 0.35s ease-in-out;
                -moz-transition: all 0.35s ease-in-out;
                -ms-transition: all 0.35s ease-in-out;
                -o-transition: all 0.35s ease-in-out;
                transition: all 0.35s ease-in-out;
                &__expand {
                  filter: invert(100%) brightness(50%);
                  -webkit-transition: all 0.35s ease-in-out;
                  -moz-transition: all 0.35s ease-in-out;
                  -ms-transition: all 0.35s ease-in-out;
                  -o-transition: all 0.35s ease-in-out;
                  transition: all 0.35s ease-in-out;
                }
              }
              &__separator {
                background-color: rgb(150, 150, 150);
                -webkit-transition: opacity 0.35s ease-in-out,
                  0.35s background-color ease-in-out;
                -moz-transition: opacity 0.35s ease-in-out,
                  0.35s background-color ease-in-out;
                -ms-transition: opacity 0.35s ease-in-out,
                  0.35s background-color ease-in-out;
                -o-transition: opacity 0.35s ease-in-out,
                  0.35s background-color ease-in-out;
                transition: opacity 0.35s ease-in-out,
                  0.35s background-color ease-in-out;
              }
            }
            &__separator {
              background-color: white;
              -webkit-transition: background-color 0.35s ease-in-out;
              -moz-transition: background-color 0.35s ease-in-out;
              -ms-transition: background-color 0.35s ease-in-out;
              -o-transition: background-color 0.35s ease-in-out;
              transition: background-color 0.35s ease-in-out;
            }
          }
          &__campos {
            &__item {
              &__title {
                color: white;
                -webkit-transition: color 0.35s ease-in-out;
                -moz-transition: color 0.35s ease-in-out;
                -ms-transition: color 0.35s ease-in-out;
                -o-transition: color 0.35s ease-in-out;
                transition: color 0.35s ease-in-out;
              }
              &__acabados {
                &__item {
                  &__miniatura {
                    &__image {
                    }
                  }
                  &__name {
                    color: white;
                    -webkit-transition: color 0.35s ease-in-out;
                    -moz-transition: color 0.35s ease-in-out;
                    -ms-transition: color 0.35s ease-in-out;
                    -o-transition: color 0.35s ease-in-out;
                    transition: color 0.35s ease-in-out;
                  }
                  &.active {
                    & .menu__caracteristicas__campos__item__acabados__item {
                      &__miniatura {
                        border: 1px solid white;
                        -webkit-transition: all 0.35s ease-in-out;
                        -moz-transition: all 0.35s ease-in-out;
                        -ms-transition: all 0.35s ease-in-out;
                        -o-transition: all 0.35s ease-in-out;
                        transition: all 0.35s ease-in-out;
                      }
                    }
                  }
                }
              }
              &__dropdown {
                &__selected {
                  border: 1px solid rgb(150, 150, 150);
                  background-color: black;
                  color: white;
                  -webkit-transition: all 0.35s ease-in-out;
                  -moz-transition: all 0.35s ease-in-out;
                  -ms-transition: all 0.35s ease-in-out;
                  -o-transition: all 0.35s ease-in-out;
                  transition: all 0.35s ease-in-out;
                  &__value {
                  }
                  &__expand {
                    filter: invert(100%);
                    -webkit-transition: filter 0.35s ease-in-out,
                      transform 0.35s ease-in-out;
                    -moz-transition: filter 0.35s ease-in-out,
                      transform 0.35s ease-in-out;
                    -ms-transition: filter 0.35s ease-in-out,
                      transform 0.35s ease-in-out;
                    -o-transition: filter 0.35s ease-in-out,
                      transform 0.35s ease-in-out;
                    transition: filter 0.35s ease-in-out,
                      transform 0.35s ease-in-out;
                  }
                }
                &__values {
                  border: 1px solid rgb(150, 150, 150);
                  background-color: black;
                  -webkit-transition: opacity 0.35s ease-in-out,
                    top 0.35s ease-in-out, color 0.35s ease-in-out,
                    border 0.35s ease-in-out, background-color 0.35s ease-in-out;
                  -moz-transition: opacity 0.35s ease-in-out,
                    top 0.35s ease-in-out, color 0.35s ease-in-out,
                    border 0.35s ease-in-out, background-color 0.35s ease-in-out;
                  -ms-transition: opacity 0.35s ease-in-out,
                    top 0.35s ease-in-out, color 0.35s ease-in-out,
                    border 0.35s ease-in-out, background-color 0.35s ease-in-out;
                  -o-transition: opacity 0.35s ease-in-out,
                    top 0.35s ease-in-out, color 0.35s ease-in-out,
                    border 0.35s ease-in-out, background-color 0.35s ease-in-out;
                  transition: opacity 0.35s ease-in-out, top 0.35s ease-in-out,
                    color 0.35s ease-in-out, border 0.35s ease-in-out,
                    background-color 0.35s ease-in-out;
                  &__item {
                    color: white;
                    -webkit-transition: all 0.35s ease-in-out;
                    -moz-transition: all 0.35s ease-in-out;
                    -ms-transition: all 0.35s ease-in-out;
                    -o-transition: all 0.35s ease-in-out;
                    transition: all 0.35s ease-in-out;
                    &:not(.active):hover {
                      background-color: rgb(100, 100, 100);
                      -webkit-transition: all 0.35s ease-in-out;
                      -moz-transition: all 0.35s ease-in-out;
                      -ms-transition: all 0.35s ease-in-out;
                      -o-transition: all 0.35s ease-in-out;
                      transition: all 0.35s ease-in-out;
                    }
                  }
                }
              }
              &__input {
                border: 1px solid rgb(150, 150, 150);
                background-color: black;
                color: white;
                -webkit-transition: all 0.35s ease-in-out;
                -moz-transition: all 0.35s ease-in-out;
                -ms-transition: all 0.35s ease-in-out;
                -o-transition: all 0.35s ease-in-out;
                transition: all 0.35s ease-in-out;
              }
            }
          }
        }
        &__resumen {
          background-color: #333333;
          -webkit-transition: background-color 0.35s ease-in-out;
          -moz-transition: background-color 0.35s ease-in-out;
          -ms-transition: background-color 0.35s ease-in-out;
          -o-transition: background-color 0.35s ease-in-out;
          transition: background-color 0.35s ease-in-out;
          &__top {
            &__title {
              color: white;
              border-bottom: 1px solid rgb(150, 150, 150);
              -webkit-transition: border-bottom 0.35s ease-in-out,
                color 0.35s ease-in-out;
              -moz-transition: border-bottom 0.35s ease-in-out,
                color 0.35s ease-in-out;
              -ms-transition: border-bottom 0.35s ease-in-out,
                color 0.35s ease-in-out;
              -o-transition: border-bottom 0.35s ease-in-out,
                color 0.35s ease-in-out;
              transition: border-bottom 0.35s ease-in-out,
                color 0.35s ease-in-out;
            }
          }
          &__grupos {
            &__item {
              border-bottom: 1px solid rgb(150, 150, 150);
              -webkit-transition: border-bottom 0.35s ease-in-out;
              -moz-transition: border-bottom 0.35s ease-in-out;
              -ms-transition: border-bottom 0.35s ease-in-out;
              -o-transition: border-bottom 0.35s ease-in-out;
              transition: border-bottom 0.35s ease-in-out;
              &__title {
                color: white;
                -webkit-transition: color 0.35s ease-in-out;
                -moz-transition: color 0.35s ease-in-out;
                -ms-transition: color 0.35s ease-in-out;
                -o-transition: color 0.35s ease-in-out;
                transition: color 0.35s ease-in-out;
              }
              &__campos {
                &__item {
                  &__title {
                    &__campo {
                      color: white;
                      -webkit-transition: color 0.35s ease-in-out;
                      -moz-transition: color 0.35s ease-in-out;
                      -ms-transition: color 0.35s ease-in-out;
                      -o-transition: color 0.35s ease-in-out;
                      transition: color 0.35s ease-in-out;
                    }
                    &__value {
                      color: white;
                      -webkit-transition: color 0.35s ease-in-out;
                      -moz-transition: color 0.35s ease-in-out;
                      -ms-transition: color 0.35s ease-in-out;
                      -o-transition: color 0.35s ease-in-out;
                      transition: color 0.35s ease-in-out;
                    }
                  }
                  &__miniatura {
                    &__image {
                    }
                  }
                  &__value {
                    color: white;
                    -webkit-transition: color 0.35s ease-in-out;
                    -moz-transition: color 0.35s ease-in-out;
                    -ms-transition: color 0.35s ease-in-out;
                    -o-transition: color 0.35s ease-in-out;
                    transition: color 0.35s ease-in-out;
                  }
                }
              }
            }
          }
          &__bottom {
            &__buy {
            }
          }
        }
      }
    }
  }
  &.hidden {
    opacity: 0;
    pointer-events: none;
    -webkit-transition: opacity 0.35s ease-in-out;
    -moz-transition: opacity 0.35s ease-in-out;
    -ms-transition: opacity 0.35s ease-in-out;
    -o-transition: opacity 0.35s ease-in-out;
    transition: opacity 0.35s ease-in-out;
  }
}
</style>
